import Client from "../client";

export default {
  // returns list of all the Insurances route
  getLinkg: (options) => Client("GET", "links", undefined, options),
};
